import { useCallback, useRef, useState } from 'react';

export function useElementWidth<T extends HTMLElement = HTMLElement>() {
  const [width, setWidth] = useState(0);
  const observerRef = useRef<ResizeObserver | null>(null);

  const ref = useCallback((node: T | null) => {
    observerRef.current?.disconnect();
    observerRef.current = null;

    if (!node) {
      setWidth(0);
      return;
    }

    setWidth(node.getBoundingClientRect().width);

    const resizeObserver = new ResizeObserver(([entry]) => {
      setWidth(entry.target.getBoundingClientRect().width);
    });

    resizeObserver.observe(node);
    observerRef.current = resizeObserver;
  }, []);

  return { ref, width };
}
